const host = "host";
const organiser = "organiser";
const admin = "admin";
const concierge = "concierge";

const isHost = (thread) => thread.viewerRole === host;
const isOrganiser = (thread) => thread.viewerRole === organiser;

module.exports = {
  host,
  organiser,
  admin,
  concierge,
  isHost,
  isOrganiser,
};
